import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10bd74fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "item-display"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dropdownlist = _resolveComponent("dropdownlist")!

  return (!_ctx.disabled)
    ? (_openBlock(), _createBlock(_component_dropdownlist, _mergeProps({
        key: 0,
        onFilterchange: _ctx.filterChange,
        onChange: _ctx.handleChange
      }, _ctx.$attrs, {
        filterable: _ctx.filterable,
        required: _ctx.required,
        valid: _ctx.required && _ctx.selected !== _ctx.t('component.dropdown.placeholder') || !_ctx.required,
        style: {
      height: '26px',
      border: '1px solid var(--primary)',
      borderRadius: '7px',
      flex: 'auto',
      backgroundColor: 'var(--white)'
    },
        popupSettings: {
      className: 'ib-drop-downs',
      height: '600px'
    },
        icon: "chevron-down",
        modelValue: _ctx.selected,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selected) = $event)),
        disabled: _ctx.disabled,
        "data-items": _ctx.items,
        "default-item": _ctx.t('component.dropdown.placeholder')
      }), null, 16, ["onFilterchange", "onChange", "filterable", "required", "valid", "style", "modelValue", "disabled", "data-items", "default-item"]))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.selected !== `${_ctx.t('component.dropdown.placeholder')}` ? _ctx.selected : ''), 1))
}